var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.cardList},_vm._l((_vm.directionList),function(item,index){return _c('div',{key:index,class:_vm.$style.card},[_c('div',{class:_vm.$style.title,style:({background: item.titleBg})},[_vm._v(_vm._s(item.title))]),_c('div',{class:_vm.$style.intro,domProps:{"innerHTML":_vm._s(item.intro)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }